import React from "react";
import "./Izzi.scss";
import data from "./data.json";
import Card from "../../../Component/Card/card";

import Castilo6images from "../../../Media/BSD/Terravia/Castilo Home/Castilo6";
import Castilo7images from "../../../Media/BSD/Terravia/Castilo Home/Castilo7";
import Castilo8images from "../../../Media/BSD/Terravia/Castilo Home/Castilo8";

const imageMap = {
  Castilo6images,
  Castilo7images,
  Castilo8images,
  // Add other image arrays here if you have more sets
};

const produk = () => {
  return (
    <div id="vireya" className="produk">
      <div className="cardhome-containerf">
        {data.cards.map((card, index) => {
          // Determine the logo dynamically
          // Determine the logo dynamically
          return (
            <Card
              key={index}
              carousel={imageMap[card.imagesKey]}
              title={card.title}
              subtitle={card.subtitle}
              price={card.price}
              subprice={card.subprice}
              details={card.details}
              whatsappLink={card.whatsappLink} // Pass the WhatsApp link
            />
          );
        })}
      </div>
    </div>
  );
};

export default produk;
